import { useCallback, useEffect, useState } from 'react';
import SendBird from 'sendbird';
import { useCommonUserProfile } from '@hooks/user';
import useUseableMessage from './useUseableMessage';
import { debounce } from 'lodash';
import type { SendBirdInstance } from 'sendbird';

export default function useUnreadMessageCount() {
  const [unreadCount, setUnreadCount] = useState<number>(0);
  const [sendbirdInstance, setSendbirdInstance] = useState<SendBirdInstance>();
  const { userProfile } = useCommonUserProfile();
  const useableMessage = useUseableMessage();

  const connectSendbird = useCallback(
    debounce(async () => {
      if (!userProfile?.userUuid || !useableMessage) {
        return;
      }

      const sendbird = new SendBird({
        appId: process.env.NEXT_PUBLIC_SENDBIRD_APP_ID as string,
      });
      setSendbirdInstance(sendbird);
      await sendbird.connect(userProfile.userUuid);
      // TODO: 유저 프로필 이미지, 닉네임 등록

      const myGroupListQuery =
        sendbird.GroupChannel.createMyGroupChannelListQuery();

      if (myGroupListQuery.hasNext) {
        myGroupListQuery.next((groupChannels) => {
          const unreadCount = groupChannels.reduce(
            (acc, { unreadMessageCount }) => acc + unreadMessageCount,
            0,
          );

          setUnreadCount(unreadCount);
        });
      }
    }, 500),
    [useableMessage, userProfile],
  );

  const disconnectSendbird = useCallback(
    () => sendbirdInstance?.disconnect(),
    [sendbirdInstance],
  );

  useEffect(() => {
    connectSendbird();
    window.addEventListener('focus', connectSendbird);
    window.addEventListener('blur', disconnectSendbird);

    return () => {
      window.removeEventListener('focus', connectSendbird);
      window.removeEventListener('blur', disconnectSendbird);
    };
  }, [connectSendbird, disconnectSendbird, sendbirdInstance]);

  return unreadCount;
}
